// Copyright (c) 2026 Boomi, LP

export const AGENT_MODE_CONVERSATIONAL = 'conversational';
export const AGENT_MODE_STRUCTURED = 'structured';
export const AGENT_MODE_DECISION = 'decision';

export type AgentMode =
  | typeof AGENT_MODE_CONVERSATIONAL
  | typeof AGENT_MODE_STRUCTURED
  | typeof AGENT_MODE_DECISION;

export const isDecisionMode = (mode?: string): boolean => mode === AGENT_MODE_DECISION;

export const isSchemaMode = (mode?: string): boolean => (
  mode === AGENT_MODE_STRUCTURED || mode === AGENT_MODE_DECISION
);

/**
 * Decision Engine is an agent mode that uses Jev (System One) for reasoning and agentic execution.
 * Keep this mapping isolated so a future backend mode can replace it cleanly.
 */
export const toBackendAgentMode = (mode?: string): string => (
  isSchemaMode(mode) ? AGENT_MODE_STRUCTURED : AGENT_MODE_CONVERSATIONAL
);

export const toModeSelectorValue = (mode?: string): string => {
  if (isDecisionMode(mode)) return AGENT_MODE_DECISION;
  if (mode === AGENT_MODE_STRUCTURED) return 'structured-data';
  return AGENT_MODE_CONVERSATIONAL;
};
